import { Box, Typography } from "@mui/material";
import React from "react";

const AboutAzad = () => {
  return (
    <Box sx={{ marginTop: "20px" }}>
      <Box sx={{ mb: "24px" }}>
        <Typography
          sx={{
            fontFamily: "Tahrir",
            fontWeight: 500,
            fontSize: "32px",
            mb: "8px",
          }}
        >
          What is Azad?
        </Typography>
        <Typography sx={{ color: "darkMute.main" }}>
          individuals who wish to share and discuss their thoughts within their
          community. In Azad, users participate in a table where they can
          publish their opinions and engage in discussions via micro-posts that
          take less than five minutes to watch. To ensure users' privacy and
          anonymity, Azad stores only the data that is public in the application
        </Typography>
      </Box>
      {/* <Box sx={{ mb: "16px" }}>
        <Typography
          sx={{
            fontFamily: "Tahrir",
            fontWeight: 500,
            fontSize: "32px",
            mb: "8px",
          }}
        >
          How does it work?
        </Typography>
        <Typography sx={{ color: "darkMute.main" }}>
          Porem ipsum dolor sit amet, consectetur adipiscing elit. Etiam eu
          turpis molestie, dictum est a, mattis tellus. Sed dignissim, metus nec
          fringilla accumsan, risus sem sollicitudin lacus, ut interdum tellus
          elit sed risus. Maecenas eget condimentum velit, sit amet feugiat
          lectus. Class aptent taciti sociosqu ad litora torquent. umsan, risus
          sem sollicitudin lacus, ut interdum tellus elit sed risus. Maecenas
          eget condimentum velit, sit amet feugiat lectus. Class aptent taciti
          sociosqu ad litora torquent.
        </Typography>
      </Box> */}
    </Box>
  );
};

export default AboutAzad;
